<template>
  <div
    class="contentStyleBody"
  >
    <div
      v-for="(item, index) in currentBillingManage"
      :key="index"
    >
      <div
        class="contentStyleBodyEl"
      >
        <div class="rightContent">
          <div class="rightContentBorder" />
          <div
            class="d-flex align-center mLeft"
            @click="showData(item.managedName)"
          >
            <v-icon
              v-if="show[getKey(item.managedName)]"
              large
              color="primary"
            >
              mdi-menu-down
            </v-icon>
            <v-icon
              v-else
              large
              color="primary"
            >
              mdi-menu-right
            </v-icon>
          </div>
          <div class="pricingPeriod">
            {{ $t(`aquassistBilling.pricingManagement.labels.${item.managedName}`) }}
            <div
              v-if="item.color"
              class="pricingPeriodPoint"
            />
          </div>
        </div>
      </div>
      <div v-if="show[getKey(item.managedName)]">
        <CurrentBillingPriceDetails
          :pricingPeriod="items.id"
          :listManage="item.managedList"
          :managedName="item.managedName"
        />
      </div>
    </div>
  </div>
</template>

<script>

import CurrentBillingPriceDetails
from '@/views/admin/aquassistBilling/billingRegisterComponent/curentBillingSummaryDetails/CurrentBillingPriceDetails.vue';

export default {
    name: 'CurrentBillingManagementDetails',
    components: { CurrentBillingPriceDetails },
    props: {
        items: {
            type: Object,
            default: () => {
            },
        },
        openAllSubItems: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            currentBillingManage: [],
            show: {},
        };
    },
    created() {
        this.initCurrentBillingManage();
    },
    methods: {
        initCurrentBillingManage() {
            this.currentBillingManage = [
                { managedList: [...this.items.users.usersDetails], managedName: 'users' },
                { managedList: [...this.items.sites.sitesDetails], managedName: 'sites' },
                { managedList: [...this.items.features.featuresDetails], managedName: 'features' },
            ];
            if (!this.openAllSubItems) {
                this.currentBillingManage.forEach(name => {
                    const key = this.getKey(name.managedName);
                    this.show = {
                        ...this.show,
                        [key]: true,
                    };
                });
            }
        },
        showData(name) {
            const key = this.getKey(name);
            this.show = {
                ...this.show,
                [key]: !this.show[key],
            };
        },
        getKey(name) {
            return `${name}_${this.items.id}`;
        },
    },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/pricingManagement.scss";
.contentStyleBody{
    padding: 0 0 0 2rem !important;
}
</style>
